import { render } from "./ViewTyrePage.vue?vue&type=template&id=61cd2bd5"
import script from "./ViewTyrePage.vue?vue&type=script&lang=js"
export * from "./ViewTyrePage.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__